import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'PercentValue',
})
export class PercentValuePipe implements PipeTransform {
	transform(priceInPermille: number, divideBy = 10): number {
		if (typeof priceInPermille !== 'number') throw new Error('Price have to be a number!');
		if (divideBy <= 0) divideBy = 1;
		return priceInPermille / divideBy;
	}
}
